import React from 'react';
import './Badge.css';

const LABELS = {
  available: 'Available',
  'coming-soon': 'Coming Soon',
};

function Badge({ status }) {
  return <span className={`badge badge--${status}`}>{LABELS[status]}</span>;
}

export default Badge;
